import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/promiseFrame/268Logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b1315282")

_pushScopeId("data-v-b1315282")
const _hoisted_1 = { class: "nevsCard" }
const _hoisted_2 = { class: "cardBox" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Проверка авто")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Проверка батареи")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_10 = { class: "cardCont" }
const _hoisted_11 = { class: "cardContItem cardContBlue" }
const _hoisted_12 = { class: "cardService" }
const _hoisted_13 = { class: "cardLevel" }
const _hoisted_14 = { class: "resultTxt" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "resTag" }, "Результат проверки", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = { class: "tag-circle-container" }
const _hoisted_18 = { class: "resbox" }
const _hoisted_19 = { class: "rectangle_resBox" }
const _hoisted_20 = { class: "rectangle_resBox_item" }
const _hoisted_21 = { class: "rectangle_resBox_item_txt" }
const _hoisted_22 = { class: "rectangle_resBox_item" }
const _hoisted_23 = { class: "rectangle_resBox_item_txt" }
const _hoisted_24 = { class: "rectangle_resBox_item" }
const _hoisted_25 = { class: "rectangle_resBox_item_txt" }
const _hoisted_26 = { class: "cardContItem cardContGreen" }
const _hoisted_27 = { class: "cardService" }
const _hoisted_28 = { class: "cardLevel" }
const _hoisted_29 = { class: "levelTxt" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-yiwen" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "resbox" }, " Показатель состояния тяговой батареи (SOH) в данном отчёте рассчитывается на основе данных протокола связи национального стандарта Китая GB/T 27930 и общего уровня деградации ёмкости батареи. Алгоритм расчёта SOH защищён патентом на изобретение, выданным Национальным управлением интеллектуальной собственности Китая (CNIPA). ", -1)
const _hoisted_32 = { class: "cardResult" }
const _hoisted_33 = { class: "cardResTop" }
const _hoisted_34 = { class: "res-col" }
const _hoisted_35 = { class: "res-num" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "res-desc" }, "Количество циклов зарядки", -1)
const _hoisted_38 = { class: "res-col" }
const _hoisted_39 = { class: "res-num" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "res-desc" }, "Расчётный запас хода при полной зарядке", -1)
const _hoisted_42 = { class: "reportMsgCont" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "localIcon",
    src: _imports_0
  })
], -1)
const _hoisted_44 = { class: "reportMsg" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "batteryPop" }
const _hoisted_47 = { class: "batteryPopTitle" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Описание оценки аккумулятора ")
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryPopCont\" data-v-b1315282><div class=\"batteryPopContTitle\" data-v-b1315282><i class=\"batteryPopContTitleLine\" data-v-b1315282></i><span class=\"batteryPopContTitleTxt\" data-v-b1315282>Оценка состояния аккумулятора</span></div><div class=\"batteryPopContTxt\" data-v-b1315282> SOH (состояние здоровья аккумулятора): показывает состояние аккумулятора в процентах. SOH = (текущая максимальная ёмкость тяговой батареи ÷ номинальная ёмкость тяговой батареи) × 100 %. </div><div class=\"batteryPopTable\" data-v-b1315282><div class=\"batteryPopTableTh\" data-v-b1315282>Рейтинг SOH 268V</div><div class=\"batteryPopTableTr\" data-v-b1315282><div class=\"batteryPopTableTd col1\" data-v-b1315282>Отличный</div><div class=\"batteryPopTableTd col2\" data-v-b1315282>90% и выше (включительно)</div></div><div class=\"batteryPopTableTr\" data-v-b1315282><div class=\"batteryPopTableTd col1\" data-v-b1315282>Хороший</div><div class=\"batteryPopTableTd col2\" data-v-b1315282>От 80% (включительно) до 90%</div></div><div class=\"batteryPopTableTr\" data-v-b1315282><div class=\"batteryPopTableTd col1\" data-v-b1315282>Средний</div><div class=\"batteryPopTableTd col2\" data-v-b1315282>От 65% (включительно) до 80%</div></div><div class=\"batteryPopTableTr\" data-v-b1315282><div class=\"batteryPopTableTd col1\" data-v-b1315282>Обычный</div><div class=\"batteryPopTableTd col2\" data-v-b1315282>Ниже 65%</div></div><div class=\"batteryPopTableTend\" data-v-b1315282> Примечание: Измеренное значение SOH тяговой батареи выражается в процентах. При отображении рейтинга батареи показывается только числовое значение перед символом процента. </div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["cardTab", {'activeGreen': _ctx.state.activeTab === 1,
                'activeBlue': _ctx.state.activeTab === 0
            }]
      }, [
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 0}],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(0)))
        }, [
          _createVNode("p", null, [
            _hoisted_3,
            _hoisted_4,
            _createVNode("b", null, _toDisplayString(_ctx.getData('rank')), 1)
          ]),
          _hoisted_5
        ], 2),
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 1}],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(1)))
        }, [
          _createVNode("p", null, [
            _hoisted_6,
            _hoisted_7,
            (_ctx.getData('soh') !== '-')
              ? (_openBlock(), _createBlock("b", _hoisted_8, _toDisplayString(_ctx.getData('soh')), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_9
        ], 2)
      ], 2),
      _createVNode("div", _hoisted_10, [
        _withDirectives(_createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.state.promiseTxt), 1),
          _createVNode("div", _hoisted_13, [
            _createVNode("img", {
              class: "levelImg",
              src: require(`../../../../../assets/batteryFrame/nevs_level_${_ctx.getData('rank')}En.png`)
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.getData('rankDesc')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createVNode("ul", _hoisted_19, [
                _createVNode("li", _hoisted_20, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_21, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                ]),
                _createVNode("li", _hoisted_22, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_23, _toDisplayString(_ctx.getData('fireFlag')), 1)
                ]),
                _createVNode("li", _hoisted_24, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_25, _toDisplayString(_ctx.getData('waterFlag')), 1)
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.state.activeTab === 0]
        ]),
        _withDirectives(_createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, _toDisplayString(_ctx.state.promiseTxt), 1),
          _createVNode("div", _hoisted_28, [
            _createVNode("div", {
              class: "reportLevel",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
            }, [
              _createVNode("h5", _hoisted_29, _toDisplayString(_ctx.getData('soh')), 1),
              _createVNode("img", {
                class: "levelImg",
                src: require('../../../../../assets/promiseFrame/batteryCar.png')
              }, null, 8, ["src"]),
              _hoisted_30,
              (_ctx.getData('soh') !== '-')
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    class: "scoreLevel",
                    style: {background: _ctx.state.scoreLevel.value}
                  }, _toDisplayString(_ctx.state.scoreLevel.contTxt), 5))
                : _createCommentVNode("", true)
            ]),
            _hoisted_31
          ]),
          _createVNode("div", _hoisted_32, [
            _createVNode("div", _hoisted_33, [
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_ctx.getData('numberOfCycles')), 1),
                  (_ctx.getData('numberOfCycles') !== '-' )
                    ? (_openBlock(), _createBlock("span", _hoisted_36, "Раз"))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_37
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode("div", _hoisted_39, [
                  _createTextVNode(_toDisplayString(_ctx.getData('kmRemain')), 1),
                  (_ctx.getData('kmRemain') !== '-' )
                    ? (_openBlock(), _createBlock("span", _hoisted_40, "Km"))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_41
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.state.activeTab === 1]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_42, [
      _hoisted_43,
      _createVNode("div", _hoisted_44, [
        _createTextVNode(" NO." + _toDisplayString(_ctx.getData('reportCode')) + " ", 1),
        (_ctx.getData("reportGenDate"))
          ? (_openBlock(), _createBlock("span", _hoisted_45, " | " + _toDisplayString(_ctx.getData('reportGenDate').replace(/-/g,'.')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.isShowBatteryPop,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.isShowBatteryPop = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _hoisted_48,
            _createVNode("i", {
              class: "iconfont icon-guanbi",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
            })
          ]),
          _hoisted_49
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})